"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  var moduleName = "common";
  var componentName = "agGrid";

  var bindings = {
    name: "=?",
    displayExportButton: "=?",
    exportFileName: "=?",
    columnDefs: "=",
    rawData: "=",
    commonCostRows: "=?",
    height: "=",
    onEvent: "&?",
    needToBeUpdate: "=?",
    filterTags: "=?",
    rowSelected: "=?",
    gridInstance: "=?",
    groupPanel: "=?",
    withoutButtons: "=?",
    onGridReady: "&"
  };

  var templateUrl = "app/ag-grid/ag-grid.html";

  function suppressColumnMoveAnimation() {
    var isFirefox = typeof InstallTrigger !== "undefined";
    // At least Safari 3+: "[object HTMLElementConstructor]"
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") > 0;
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    return isFirefox || isSafari || isIE;
  }

  var groupColumn = {
    headerName: "Group",
    width: 200,
    field: "name",
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    cellRenderer: "group",
    cellRendererParams: {
      checkbox: true
    }
  };

  function selectionChanged(event) {
    //console.log('Callback selectionChanged: selection count = ' + gridOptions.api.getSelectedNodes().length);
  }

  function rowSelected(event) {
    // the number of rows selected could be huge, if the user is grouping and selects a group, so
    // to stop the console from clogging up, we only print if in the first 10 (by chance we know
    // the node id's are assigned from 0 upwards)
    if (event.node.id < 10) {
      var valueToPrint = event.node.group ? "group (" + event.node.key + ")" : event.node.data.name;
      //console.log("Callback rowSelected: " + valueToPrint + " - " + event.node.isSelected());
    }
  }

  function getContextMenuItems(params) {
    var that = this;
    var result = ["copy", "separator", {
      name: "Export EXCEL",
      action: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var sheet;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return that.getSheetDataForExcel();

                case 2:
                  sheet = _context.sent;
                  _context.next = 5;
                  return that.exportMultipleSheetsAsExcel("export-excel.xlsx", [sheet]);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function action() {
          return _ref.apply(this, arguments);
        }

        return action;
      }(),
      icon: '<img src="assets/ms-excel.svg" />'
    }];
    return result;
  }

  var Controller = function () {
    /** @ngInject */
    function Controller($log, $scope, $timeout, AgGridLocale) {
      _classCallCheck(this, Controller);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.filterTags = [];
      this.AgGridLocale = AgGridLocale;
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this,
            _gridOptions;

        var ctrl = this;

        console.log("$onInit ag-grid :" + this.exportFileName);
        console.log("this.columnDefs=" + this.columnDefs);
        this.runExport = function () {
          this.onEvent({ value: { type: "exportButton" } });
        };

        this.gridOptions = (_gridOptions = {
          columnDefs: this.columnDefs,
          tooltipShowDelay: 500,
          rowData: this.rawData ? this.rawData : [],
          suppressMenuHide: true,
          // https://www.ag-grid.com/angular-data-grid/clipboard/
          suppressCopyRowsToClipboard: true,
          excelStyles: [{
            id: "header",
            alignment: {
              vertical: "Center",
              horizontal: "Center"
            },
            interior: {
              color: "#d3dcef",
              pattern: "Solid"
            },
            borders: {
              borderBottom: {
                color: "#babfc7",
                lineStyle: "Continuous",
                weight: 1
              }
            },
            font: { color: "#000000", bold: true }
          }, {
            id: "headerGroup",
            font: {
              bold: true
            },
            alignment: {
              vertical: "Center",
              horizontal: "Center"
            }
          }, {
            id: "date-iso",
            dataType: "DateTime",
            numberFormat: {
              format: "dd/mm/yyyy"
            }
          }, {
            id: "hour-iso",
            dataType: "DateTime",
            numberFormat: {
              format: "hh:mm"
            }
          }, {
            id: "pourcentage-format",
            numberFormat: {
              format: "0%"
            }
          }, {
            id: "currency-format",
            numberFormat: {
              format: "#,##0.00 €"
            }
          }, {
            id: "cell-default-background",
            interior: {
              color: "#ffffff",
              pattern: "Solid"
            }
          }, {
            id: "cell-centered",
            alignment: {
              vertical: "Center",
              horizontal: "Center"
            }
          }, {
            id: "cell-right",
            alignment: {
              vertical: "Right",
              horizontal: "Right"
            }
          }, {
            id: "has-text-weight-bold",
            font: {
              bold: true
            }
          }],

          localeText: this.AgGridLocale.fr,

          //angularCompileRows: true,
          enableColResize: true,
          enableSorting: true,
          rowSelection: "multiple",
          floatingFilter: false,

          rowGroupPanelShow: this.groupPanel == false ? "never" : "always",

          isExternalFilterPresent: this.isExternalFilterPresent,
          doesExternalFilterPass: this.doesExternalFilterPass,

          getRowStyle: function getRowStyle(params) {
            //console.log("check style", params.data);
            if (params.data && params.data.backgroundColor) {
              return { "background-color": params.data.backgroundColor };
            }
          },

          //onColumnEverythingChanged: () => { this.saveColumnsState() },
          onColumnVisible: function onColumnVisible() {
            _this.saveColumnsState();
          },
          onColumnPinned: function onColumnPinned() {
            _this.saveColumnsState();
          },
          onColumnResized: function onColumnResized() {
            _this.saveColumnsState();
          },
          onColumnRowGroupChanged: function onColumnRowGroupChanged() {
            _this.saveColumnsState();
          },
          onDisplayedColumnsChanged: function onDisplayedColumnsChanged() {
            console.log("onColumnGroupOpened");
            //this.saveColumnsState()
          },
          onFilterOpened: function onFilterOpened(params) {
            console.log("onFilterOpened", params.column);
            setTimeout(function () {
              var virtualList = document.querySelector(".ag-virtual-list-container");
              if (virtualList) {
                // Récupérer la largeur de la colonne
                var columnWidth = params.column.getActualWidth();

                var allValues = [];

                // Obtenir toutes les lignes affichées
                var rowCount = _this.gridOptions.api.getDisplayedRowCount();

                console.log(params.column.colId);

                for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                  var rowNode = _this.gridOptions.api.getDisplayedRowAtIndex(rowIndex); // Récupère le nœud de la ligne
                  var value = rowNode.data[params.column.colId]; // Récupère la valeur de la colonne spécifique
                  allValues.push(value ? value.length : 0); // Ajoute la longueur de la valeur à un tableau
                }

                var maxWidth = Math.max.apply(Math, allValues) * 7; // Trouver la largeur maximale de la valeur
                if (maxWidth < columnWidth) {
                  maxWidth = columnWidth; // Si la largeur de la colonne est plus grande que la largeur maximale de la valeur, utiliser la largeur de la colonne
                }

                // Appliquer la nouvelle largeur avec un petit padding
                virtualList.style.setProperty("width", maxWidth + 20 + "px", "important");
              }
            }, 100); // Timeout pour éviter les conflits avec AG Grid
          },
          onRowDataChanged: function onRowDataChanged() {
            return _this.refreshCommonCosts();
          },
          onFilterChanged: function onFilterChanged() {
            _this.refreshCommonCosts();
            console.log("onFilterChanged");
            _this.saveFilterModel();

            // Obtenir toutes les lignes affichées
            _this.rowCount = _this.gridOptions.api.getDisplayedRowCount();
          },

          //onColumnValueChanged: () => { this.saveColumnsState() },
          onColumnMoved: function onColumnMoved() {
            _this.saveColumnsState();
          },
          onColumnGroupOpened: function onColumnGroupOpened() {
            _this.saveColumnsState();
          },

          onRowSelected: function onRowSelected(event) {
            event.node.checkbox = event.node.selected;
          },

          onRowClicked: function onRowClicked(event) {
            _this.onEvent({ type: "onRowClicked", value: event });
          },
          onRowDoubleClicked: function onRowDoubleClicked(event) {
            _this.onEvent({ type: "onRowDoubleClicked", value: event });
          },

          onSelectionChanged: function onSelectionChanged() {
            _this.$timeout(function () {
              _this.rowSelected = _this.gridOptions.api.getSelectedNodes();
            }, 20);
          },

          onFirstDataRendered: function onFirstDataRendered() {
            _this.refreshCommonCosts();
            console.log("onFirstDataRendered");
            if (_this.name) {
              // Repêchage des anciens filtres (avant le bug de la version 2.0.185)
              var old1FilterModel = localStorage.getItem(_this.name + "-2.0.185-filterModel");
              if (old1FilterModel) {
                localStorage.setItem(_this.name + "-filterModel", old1FilterModel);
                localStorage.removeItem(_this.name + "-2.0.185-filterModel");
              }
              // Repêchage des anciens filtres (avant le bug de la version 2.0.185)
              var old2FilterModel = localStorage.getItem(_this.name + "-{{vm.$version}}-filterModel");
              if (old2FilterModel) {
                localStorage.setItem(_this.name + "-filterModel", old2FilterModel);
                localStorage.removeItem(_this.name + "-{{vm.$version}}-filterModel");
              }

              var filterModel = JSON.parse(localStorage.getItem(_this.name + "-filterModel"));

              if (filterModel) {
                console.log(_this.name + " apply filterModel", filterModel);
                _this.gridOptions.api.setFilterModel(filterModel);

                _this.refreshFilterButtons();
              }
            }

            // Set columns size to fit content
            _this.autoSizeAll(false);
          },

          onGridSizeChanged: function onGridSizeChanged() {
            console.log("onGridSizeChanged");
            _this.autoSizeAll(false);
          },

          onGridReady: function onGridReady(gridOptions) {
            console.log("onGridReady");

            // Transmettre l'API au parent
            ctrl.onGridReady({
              api: _this.gridOptions.api,
              exportSheet: function exportSheet() {
                return ctrl.exportSheet();
              }
            });

            _this.$timeout(function () {
              console.log("apply previous grid state");

              if (_this.name) {
                // Repêchage des anciens états des colonnes (avant le bug de la version 2.0.185)
                var old1ColumnsState = localStorage.getItem(_this.name + "-2.0.185-columnsState");
                if (old1ColumnsState) {
                  localStorage.setItem(_this.name + "-columnsState", old1ColumnsState);
                  localStorage.removeItem(_this.name + "-2.0.185-columnsState");
                }
                // Repêchage des anciens états des colonnes (avant le bug de la version 2.0.185)
                var old2ColumnsState = localStorage.getItem(_this.name + "-{{vm.$version}}-columnsState");
                if (old2ColumnsState) {
                  localStorage.setItem(_this.name + "-columnsState", old2ColumnsState);
                  localStorage.removeItem(_this.name + "-{{vm.$version}}-columnsState");
                }

                //console.log('load ', this.name + '-columnsState')
                var columnsState = localStorage.getItem(_this.name + "-columnsState");

                //console.log('read state=', state)
                if (columnsState) {
                  //gridOptions.columnApi.setColumnState(columnsState)

                  gridOptions.columnApi.applyColumnState({
                    state: JSON.parse(columnsState),
                    applyOrder: true
                  });
                }

                // Repêchage des anciens états des groupes (avant le bug de la version 2.0.185)
                var old1GroupsState = localStorage.getItem(_this.name + "-2.0.185-groupsState");
                if (old1GroupsState) {
                  localStorage.setItem(_this.name + "-groupsState", old1GroupsState);
                  localStorage.removeItem(_this.name + "-2.0.185-groupsState");
                }
                // Repêchage des anciens états des groupes (avant le bug de la version 2.0.185)
                var old2GroupsState = localStorage.getItem(_this.name + "-{{vm.$version}}-groupsState");
                if (old2GroupsState) {
                  localStorage.setItem(_this.name + "-groupsState", old2GroupsState);
                  localStorage.removeItem(_this.name + "-{{vm.$version}}-groupsState");
                }

                var groupsState = JSON.parse(localStorage.getItem(_this.name + "-groupsState"));

                if (groupsState) {
                  gridOptions.columnApi.setColumnGroupState(groupsState);
                }
              }

              setTimeout(function () {
                _this.gridReady = true;
              }, 2500);
            }, 500);
          },

          defaultColDef: {
            minWidth: 50,
            sortable: true,
            comparator: function comparator(a, b) {
              if (typeof a === "string") {
                return a.localeCompare(b);
              } else {
                return a > b ? 1 : a < b ? -1 : 0;
              }
            },
            filterParams: { newRowsAction: "keep" }
          },
          enableCellChangeFlash: true,
          // ensureDomOrder: true,
          // postProcessPopup: function(params) {
          //     //console.log(params);
          // },
          // need to be careful here inside the normal demo, as names are not unique if big data sets
          // getRowNodeId: function(data) {
          //     return data.name;
          // },
          // suppressAsyncEvents: true,
          // suppressAggAtRootLevel: true,
          //debug: true,
          //     editType: 'fullRow',
          //suppressEnterprise: true,
          //     debug: true,

          // rowGroupPanelShow: 'always', // on of ['always','onlyWhenGrouping']

          //pivotPanelShow: 'always', // on of ['always','onlyWhenPivoting']
          //pivotTotals: true,

          pivotColumnGroupTotals: "after",
          //minColWidth: 50,
          //maxColWidth: 300,
          rowBuffer: 0,
          //columnDefs: [],
          //singleClickEdit: true,
          // suppressClickEdit: true,
          //rowData: [
          //    {name: 'Niall'},
          //    {name: 'Eamon'},
          //    {name: 'Kevin'},
          //    {name: 'Brian'}
          //],
          //groupKeys: undefined, //set as string of keys eg ["region","country"],
          // groupUseEntireRow: true, //one of [true, false]
          //        groupDefaultExpanded: 9999, //one of [true, false], or an integer if greater than 1
          //            headerHeight: 100, // set to an integer, default is 25, or 50 if grouping columns
          //        groupSuppressAutoColumn: true,
          //groupSuppressBlankHeader: true,
          //suppressMovingCss: true,
          //suppressMovableColumns: true,
          //groupIncludeFooter: true,
          suppressColumnMoveAnimation: suppressColumnMoveAnimation(),
          // suppressTouch: true,
          // suppressDragLeaveHidesColumns: true,
          //unSortIcon: true,
          //     rowHeight: 30, // defaults to 25, can be any integer
          //     enableRtl: true,
          animateRows: true
        }, _defineProperty(_gridOptions, "enableColResize", true), _defineProperty(_gridOptions, "enableSorting", true), _defineProperty(_gridOptions, "enableFilter", true), _defineProperty(_gridOptions, "enableStatusBar", true), _defineProperty(_gridOptions, "enableRangeSelection", true), _defineProperty(_gridOptions, "rowSelection", "multiple"), _defineProperty(_gridOptions, "rowDeselection", true), _defineProperty(_gridOptions, "quickFilterText", null), _defineProperty(_gridOptions, "groupSelectsChildren", true), _defineProperty(_gridOptions, "autoGroupColumnDef", groupColumn), _defineProperty(_gridOptions, "toolPanelSuppressSideButtons", true), _defineProperty(_gridOptions, "showToolPanel", false), _defineProperty(_gridOptions, "icons", {
          //menu: '<i class="fa fa-bars"/>',
          //columnVisible: '<i class="fa fa-eye"/>',
          //columnHidden: '<i class="fa fa-eye-slash"/>',
          columnRemoveFromGroup: '<i class="fa fa-remove"/>',
          filter: '<i class="fa fa-filter"/>',
          sortAscending: '<i class="fa fa-long-arrow-down"/>',
          sortDescending: '<i class="fa fa-long-arrow-up"/>'
          // groupExpanded: '<i class="fa fa-minus-square-o"/>',
          // groupContracted: '<i class="fa fa-plus-square-o"/>',
          // columnGroupOpened: '<i class="fa fa-minus-square-o"/>',
          // columnGroupClosed: '<i class="fa fa-plus-square-o"/>'
        }), _defineProperty(_gridOptions, "getContextMenuItems", function getContextMenuItems(params) {
          var result = ["copy", "separator", {
            name: "Export EXCEL",
            action: function action() {
              _this.onEvent({ value: { type: "exportButton" } });
            },
            icon: '<img src="assets/ms-excel.svg" />'
          }];
          return result;
        }), _gridOptions);

        this.$scope.$watch(function () {
          return _this.filterTags ? _this.filterTags.length : 0;
        }, function () {
          _this.gridOptions.filterTags = _this.filterTags;

          _this.gridOptions.api.setRowData([]);

          _this.gridOptions.api.setRowData(_this.rawData);
        });

        this.$scope.$watch(function () {
          return _this.needToBeUpdate ? _this.needToBeUpdate : false;
        }, function () {
          //console.log('needToBeUpdate')

          _this.gridOptions.api.setRowData(_this.rawData);

          _this.needToBeUpdate = false;
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(what) {
        //console.log('ag-grid on change', what)
        if (what.rawData) {
          this.refresh();
        }
      }
    }, {
      key: "refreshCommonCosts",
      value: function refreshCommonCosts(forExport) {
        if (!this.commonCostRows || !this.gridOptions || !this.gridOptions.api) return;
        var rows = [];
        this.gridOptions.api.forEachNodeAfterFilter(function (node) {
          if (node.data && !node.group) rows.push(node.data);
        });
        this.gridOptions.api.setPinnedBottomRowData(this.commonCostRows(rows, forExport));
      }
    }, {
      key: "refresh",
      value: function refresh() {
        if (this.gridOptions) {
          this.gridOptions.api.setRowData(this.rawData);
          this.autoSizeAll(false);
        }
      }
    }, {
      key: "sizeColumnsToFit",
      value: function sizeColumnsToFit() {
        this.gridOptions.api.sizeColumnsToFit();
      }
    }, {
      key: "saveColumns",
      value: function saveColumns() {
        var _this2 = this;

        Notiflix.Confirm.show("Attention", "Voulez-vous vraiment sauvegarder cette disposition (écrasera la précédente sauvegarde) ?", "Oui", "Non", function () {
          localStorage.setItem("my-grid-state-" + _this2.name, JSON.stringify(_this2.gridOptions.columnApi.getColumnState()));
          Notiflix.Notify.success("Disposition sauvegardée");
        }, function () {});
      }
    }, {
      key: "restoreColumns",
      value: function restoreColumns() {
        var state = localStorage.getItem("my-grid-state-" + this.name);
        if (state) {
          this.gridOptions.columnApi.applyColumnState({
            state: JSON.parse(state),
            applyOrder: true
          });
          localStorage.setItem(this.name + "-columnsState", JSON.stringify(JSON.parse(state)));
          Notiflix.Notify.success("Disposition restaurée");
        } else {
          Notiflix.Notify.failure("Aucune disposition sauvegardée");
        }
      }
    }, {
      key: "resetColumns",
      value: function resetColumns() {
        this.gridOptions.columnApi.resetColumnState();
        this.autoSizeAll(false);
        localStorage.removeItem(this.name + "-groupsState");
        localStorage.removeItem(this.name + "-columnsState");
        localStorage.removeItem(this.name + "-filterModel");
      }
    }, {
      key: "autoSizeAll",
      value: function autoSizeAll(skipHeader) {
        var allColumnIds = [];
        this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });

        this.gridOptions.columnApi.autoSizeColumns(allColumnIds, skipHeader);
      }
    }, {
      key: "expandAll",
      value: function expandAll(expand) {
        var _this3 = this;

        this.columnDefs.forEach(function (column) {
          if (column.groupId) {
            _this3.gridOptions.columnApi.setColumnGroupOpened(column.groupId, expand);
          }
        });
      }
    }, {
      key: "hideFloatingFilter",
      value: function hideFloatingFilter() {
        var _this4 = this;

        this.gridOptions.floatingFilter = !this.gridOptions.floatingFilter;
        var colDefs = this.gridOptions.api.getColumnDefs();
        colDefs.forEach(function (colDef) {
          if (colDef.children) {
            colDef.children.forEach(function (child) {
              child.floatingFilter = _this4.gridOptions.floatingFilter;
            });
          } else {
            colDef.floatingFilter = _this4.gridOptions.floatingFilter;
          }
        });
        this.gridOptions.api.setColumnDefs(colDefs);
        this.gridOptions.api.refreshHeader();
      }
    }, {
      key: "isExternalFilterPresent",
      value: function isExternalFilterPresent() {
        return true;
      }
    }, {
      key: "doesExternalFilterPass",
      value: function doesExternalFilterPass(val) {
        if (!this.filterTags) {
          return true;
        }

        var result = 0;

        var keyValue = [];
        var why = [];

        for (var key in val.data) {
          if (val.data.hasOwnProperty(key)) {
            var value = val.data[key];

            keyValue.push(key + "=" + value);

            if (value) {
              value = value.toString().toLowerCase().replace(/[àáâãäå]/g, "a").replace(/æ/g, "ae").replace(/ç/g, "c").replace(/[èéêë]/g, "e").replace(/[ìíîï]/g, "i").replace(/ñ/g, "n").replace(/[òóôõö]/g, "o").replace(/œ/g, "oe").replace(/[ùúûü]/g, "u").replace(/[ýÿ]/g, "y");

              var filterTags = [];
              for (var i = 0; i < this.filterTags.length; i++) {
                var filterTag = this.filterTags[i].text.toLowerCase().replace(/[àáâãäå]/g, "a").replace(/æ/g, "ae").replace(/ç/g, "c").replace(/[èéêë]/g, "e").replace(/[ìíîï]/g, "i").replace(/ñ/g, "n").replace(/[òóôõö]/g, "o").replace(/œ/g, "oe").replace(/[ùúûü]/g, "u").replace(/[ýÿ]/g, "y");

                filterTags.push({ text: filterTag });
              }

              for (var i = 0; i < filterTags.length; i++) {
                var match = value.indexOf(filterTags[i].text.toLowerCase()) > -1 ? 1 : 0;

                if (match === 1) {
                  if (why.indexOf(filterTags[i].text) === -1) {
                    why.push(filterTags[i].text);
                  }
                }

                result += match;
              }
            }
          }
        }

        //console.log('why=', why)

        if (why.length === this.filterTags.length) {
          //console.log('found val', result, val)
          //console.log('why=', why)
          //console.log('keyValue=', keyValue)
          return true;
        }

        //console.log('not found', val);
        return false;
      }
    }, {
      key: "refreshFilterButtons",
      value: function refreshFilterButtons() {
        var _this5 = this;

        var savedFilterModel = this.gridOptions.api.getFilterModel();

        console.log("savedFilterModel", savedFilterModel);
        var columns = Object.keys(savedFilterModel);

        var filterColumns = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var column = _step.value;

            filterColumns.push({
              name: this.gridOptions.columnApi.getColumn(column).colDef.headerName,
              key: column
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$timeout(function () {
          _this5.filterColumns = filterColumns;
        }, 1000);
      }
    }, {
      key: "saveFilterModel",
      value: function saveFilterModel() {
        if (this.gridReady == true && this.name) {
          var savedFilterModel = this.gridOptions.api.getFilterModel();

          localStorage.setItem(this.name + "-filterModel", JSON.stringify(savedFilterModel));

          this.refreshFilterButtons();
        }
      }
    }, {
      key: "removeFilterOnColumn",
      value: function removeFilterOnColumn(key) {
        var filterModel = this.gridOptions.api.getFilterModel();
        delete filterModel[key];

        this.gridOptions.api.setFilterModel(filterModel);
      }
    }, {
      key: "saveColumnsState",
      value: function saveColumnsState() {
        var _this6 = this;

        if (this.gridReady === true && this.name) {
          //console.log('need to save state')

          if (this.storeStateTimeout) {
            this.$timeout.cancel(this.storeStateTimeout);
          }

          this.storeStateTimeout = this.$timeout(function () {
            //console.log('save ', this.name + '-columnsState')

            try {
              var columnsState = _this6.gridOptions.columnApi.getColumnState();
              localStorage.setItem(_this6.name + "-columnsState", JSON.stringify(columnsState));

              var groupsState = _this6.gridOptions.columnApi.getColumnGroupState();
              localStorage.setItem(_this6.name + "-groupsState", JSON.stringify(groupsState));

              //console.log('saveColumnsState', localStorage.getItem('columnsState'))
            } catch (e) {}

            delete _this6.storeStateTimeout;
          }, 2000);
        }
      }
    }, {
      key: "exportCsv",
      value: function exportCsv() {
        var params = {
          skipHeader: false,
          columnGroups: false,
          skipFooters: false,
          skipGroups: false,
          skipPinnedTop: false,
          skipPinnedBottom: false,
          allColumns: true,
          onlySelected: false,
          suppressQuotes: false,
          fileName: "export.txt",
          columnSeparator: ";"
        };

        this.refreshCommonCosts(true);
        try {
          this.gridOptions.api.exportDataAsCsv(params);
        } finally {
          this.refreshCommonCosts();
        }
      }
    }, {
      key: "exportSheet",
      value: function exportSheet() {
        this.refreshCommonCosts(true);
        var keysToExport = [];

        var columnDefs = this.gridOptions.api.getColumnDefs();
        console.log("export columnDef", columnDefs);

        function filter(columnDefs) {
          columnDefs.map(function (column) {
            if (typeof column.export == "undefined" || column.export == true) {
              keysToExport.push(column.colId);
            }

            if (column.children) {
              filter(column.children);
            }
          });
        }

        filter(columnDefs);

        function isIsoDate(str) {
          if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
          var d = new Date(str);
          return d instanceof Date && !isNaN(d) && d.toISOString() === str; // valid date
        }

        var newParams = {
          sheetName: this.exportFileName,
          skipPinnedBottom: false,
          columnKeys: keysToExport,
          processCellCallback: function processCellCallback(params) {
            var cellValue = void 0;
            //console.log("processCellCallback", params);
            var field = params.column.colDef.field;
            var data = params.node.data[field];

            if (typeof data !== "undefined" && data !== null) {
              if (data.text) {
                data = data.text;
              }

              if (data === true) {
                data = "OUI";
              } else if (data === false) {
                data = "NON";
              }

              if (isIsoDate(data)) {
                data = moment.tz(data, "Europe/Paris").format("YYYY-MM-DDTHH:mm:ss");
              }
            }

            return data ? String(data) : "";
          }
        };

        try {
          return this.gridOptions.api.getSheetDataForExcel(newParams);
        } finally {
          this.refreshCommonCosts();
        }
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    transclude: true,

    controller: Controller
  });
})();